<template>
  <div class="lz-field">
    <label class="lz-field-label" for="vatVal"
      >VAT
      <b-icon
        icon="info-circle-fill"
        class="lz-hint-icon"
        id="vatInfo"></b-icon>
    </label>
    <b-form-input
      :value="vat.amount"
      :disabled="showPercentageButtons && selectedVat !== 'other'"
      @change="vatChanged"
      id="vatVal"
      type="number"
      class="form-control"></b-form-input>
    <b-popover
      target="vatInfo"
      triggers="hover focus"
      placement="bottom"
      content="VAT is only applicable for UK expenses"></b-popover>
    <!-- <b-form-radio-group
      v-if="showPercentageButtons"
      :options="vatOptions"
      name="radio-inline"
      buttons
      button-variant="outline-info"
      size="sm"
      class="lz-currency-group mt-2"
      v-model="selectedVat"
      @change="vatChanged"></b-form-radio-group> -->
  </div>
</template>

<script>
export default {
  name: 'VATSelector',
  data() {
    return {
      selectedVat: 'other',
      vatOptions: [
        { text: '0%', value: '0' },
        { text: '20%', value: '20' },
        { text: 'Other', value: 'other' }
      ],
      showPercentageButtons: false
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    amount() {
      return this.FormData.amount
    },
    vat() {
      return this.FormData.vat
    }
  },
  methods: {
    vatChanged(value) {
      this.$store.commit('setFormDataVat', {
        amount: value,
        value: this.selectedVat
      })
      // const newAmount =
      //   this.selectedVat === 'other'
      //     ? this.vat.amount
      //     : (this.amount * parseInt(value)) / 100
      // this.$store.commit('modifyFormData', {
      //   key: 'amount',
      //   value: newAmount
      // })
      // this.vat = {
      //   value:
      //     this.vatOptions.findIndex((itm) => itm.value == value) == -1
      //       ? 'other'
      //       : value,
      //   amount
      // }
      // this.$root.$emit('vat-changed', this.vat)
    }
  },
  watch: {
    // 'formData.vat': {
    //   handler(vat) {
    //     this.vat = vat
    //     this.selectedVat = vat.value
    //   },
    //   deep: true
    // }
  }
}
</script>
